import * as H from 'history';
import React from 'react';
import { RouteComponentProps } from 'react-router';

import { LoginForm } from './componentes';
import { PrimerCambioDeContraseña } from './paginas';

interface Props extends RouteComponentProps<{}, {}, { rutaOrigen: H.Location } | undefined> {
    /**
     * La función será llamada con las credenciales indicadas por el usuario y esperará
     * a que la promesa se resuelva. Si se resuelve a `true` el usuario está auntenticado
     * y se procederá a la página principal, si se resuelve a `false` el usuario tiene
     * credenciales correctas pero debe cambiar la contraseña. Si algo falla, la promesa
     * debe rechazarse con un `Error` indicando la razón.
     */
    autenticar(usuario: string, contraseña: string): Promise<boolean>;

    /**
     * La función será llamada con las credenciales antiguas y nuevas y esperará a que la
     * promesa se resuelva. La promesa solo debería resolverse si el cambio de contraseña
     * fue satisfactorio y fue posible autenticar (y obtener un token) con las nuevas
     * credenciales; caso contrario la promesa debe rechazarse con un `Error` indicando
     * la razón.
     */
    cambiarContraseñaYReautenticar(usuario: string, actual: string, nueva: string): Promise<void>;
}

interface State {
    usuario: string;
    contraseña: string;
    cargando: boolean;
    mensajeDeError?: string;
    cambioDeContraseñaRequerido: boolean;
}

const stateInicial: State = {
    usuario: '',
    contraseña: '',
    cargando: false,
    cambioDeContraseñaRequerido: false,
};

class Login extends React.Component<Props, State> {
    public state: State = { ...stateInicial };

    public render() {
        const {
            cargando,
            mensajeDeError,
            usuario,
            contraseña,
            cambioDeContraseñaRequerido,
        } = this.state;
        const { cambiarContraseñaYReautenticar: cambiarContraseña } = this.props;

        return cambioDeContraseñaRequerido ? (
            <PrimerCambioDeContraseña
                cambiarContraseña={async (...args) => {
                    await cambiarContraseña(...args);
                    this.irAPaginaPrincipal();
                }}
                nombreDeUsuario={usuario}
                contraseñaActual={contraseña}
            />
        ) : (
            <LoginForm
                usuario={usuario}
                contraseña={contraseña}
                cargando={cargando}
                mensajeDeError={mensajeDeError}
                alCambiarTextos={this.alCambiarTextos}
                alPresionarBoton={this.iniciarSesion}
            />
        );
    }

    private readonly alCambiarTextos = (campos: { usuario: string; contraseña: string }) => {
        this.setState({ ...campos, mensajeDeError: undefined });
    };

    private readonly iniciarSesion = () => {
        const { usuario, contraseña } = this.state;

        this.setState({ cargando: true, mensajeDeError: undefined });

        if (usuario.length === 0 || contraseña.length === 0) {
            this.setState({
                cargando: false,
                mensajeDeError: 'Debe ingresar nombre de usuario y contraseña.',
            });
            return;
        }

        const { autenticar } = this.props;
        autenticar(usuario, contraseña)
            .then(autenticado => {
                if (autenticado) {
                    this.irAPaginaPrincipal();
                } else {
                    this.setState({ cambioDeContraseñaRequerido: true });
                }
            })
            .catch(error => {
                this.setState({
                    cargando: false,
                    contraseña: '',
                    mensajeDeError: error.message,
                });
            });
    };

    private irAPaginaPrincipal() {
        const { history, location } = this.props;

        if (!location.state) {
            history.push('/');
            return;
        }

        const { rutaOrigen } = location.state;
        history.replace(rutaOrigen.pathname !== '/login' ? rutaOrigen : { pathname: '/' });
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/paginas/Login/index.tsx